<div class="app-container">
  <app-skip-links></app-skip-links>

  <header id="main-navigation" tabindex="-1">
    <app-navbar></app-navbar>
    <app-menu mobileOnly tabindex="-1"></app-menu>
    <app-breadcrumb></app-breadcrumb>
  </header>

  <main id="main-content" class="app-content" tabindex="-1">
    <router-outlet></router-outlet>
  </main>

  <footer id="main-footer" tabindex="-1">
    <app-footer></app-footer>
  </footer>
</div>

<!-- Global Dialog Component -->
<app-dialog
  *ngIf="isDialogVisible"
  [headline]="dialogConfig.headline"
  [text]="dialogConfig.text"
  [isVisible]="isDialogVisible"
  (closed)="closeDialog()" />
